import { downgradeInjectable } from '@angular/upgrade/static';
import { EnvironmentFacade } from '@mode/shared/environment/contract';
import * as angular from 'angular';

export const DowngradedSharedEnvironmentContract = angular
  .module('downgraded-shared-environment-contract', [])
  .service('EnvironmentFacade', downgradeInjectable(EnvironmentFacade)).name;
